<template>
  <div>
    <Schedule />
  </div>
</template>

<script>
import Schedule from '../components/schedule/export/scheduleExport.vue'
export default {
  components: {
    Schedule,
  },
}
</script>

<style lang="scss" scoped></style>
